module.exports = __webpack_public_path__ + "static/img/form3.d028f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/form3.jpg
// module id = LaSd
// module chunks = 0